import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Is this a physical or digital product?',
    a: 'It is a 100% digital product (High-Resolution PDF). Optimized to be viewed on a Smartphone, Tablet, or Laptop directly on the court.'
  }, {
    q: 'Do I get updates?',
    a: 'Yes! Any future improvements to the VolleyReady system will be sent to your email for free.'
  }, {
    q: 'Do I need to be an expert coach to use this?',
    a: 'No. The system is designed both for beginners who need a guide and for veterans who want to save time.'
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8 border-t border-pilates-slate/10" data-id="element-65">
      <div className="max-w-3xl mx-auto" data-id="element-66">
        <div className="text-center mb-12" data-id="element-67">
          <div className="border border-pilates-blue-dark text-pilates-blue-dark font-semibold text-xs px-4 py-1.5 mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-68">
            FREQUENTLY ASKED QUESTIONS
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-blue-dark leading-tight tracking-tight" data-id="element-69">
            Answers to{' '}
            <span className="italic text-pilates-rose" data-id="element-70">your questions</span>
          </h2>
        </div>

        <div className="space-y-3" data-id="element-71">
          {faqs.map((faq, idx) => <div key={idx} className={`bg-white rounded-md border-y border-r border-pilates-slate/10 overflow-hidden shadow-sm transition-colors border-l-4 ${open === idx ? 'border-l-pilates-lavender' : 'border-l-pilates-blue-dark'}`} data-id="element-72">
              <button onClick={() => setOpen(open === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left hover:bg-pilates-soft transition-colors" data-id="element-73">
                <span className="font-display font-semibold text-pilates-blue-dark text-base sm:text-lg pr-4" data-id="element-74">
                  {faq.q}
                </span>
                <div className="flex-shrink-0 bg-pilates-blue-dark text-pilates-lavender w-8 h-8 rounded-sm flex items-center justify-center" data-id="element-75">
                  {open === idx ? <Minus className="w-4 h-4" data-id="element-76" /> : <Plus className="w-4 h-4" data-id="element-77" />}
                </div>
              </button>
              {open === idx && <div className="px-5 pb-5 text-pilates-slate leading-relaxed" data-id="element-78">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}